select(data-hook="quick-select").select-plain.quick-select
  option(value="all", selected) Alle
  each location in collection
    //- only saved locations
    if location.id
      option(value=location.id) #{location.name}
